const text = (value) => (typeof value === "string" ? value.trim() : "");

const hasContentValue = (item) =>
  Boolean(
    text(item?.heading) ||
      text(item?.subHeading) ||
      text(item?.description) ||
      item?.imageFile ||
      item?.image?.url ||
      item?.video?.url,
  );

const cleanContents = (contents = []) =>
  contents
    .filter(hasContentValue)
    .filter((item) => text(item.heading) && text(item.description));

const cleanFeatures = (features = []) =>
  features
    .map((feature) => ({
      ...feature,
      items: (feature.items || []).filter(
        (item) => text(item?.key) && text(item?.value),
      ),
    }))
    .filter(
      (feature) =>
        text(feature.heading) &&
        text(feature.description),
    );

const cleanSections = (sections = []) =>
  sections
    .map((section) => ({
      ...section,
      cards: (section.cards || []).filter(
        (card) =>
          text(card?.title || card?.key) ||
          text(card?.description || card?.value),
      ),
    }))
    .filter(
      (section) =>
        text(section.heading) ||
        text(section.description) ||
        section.imageFile ||
        section.image?.url ||
        section.video?.url ||
        section.cards.length,
    );

export const validatePageAdminForm = ({
  images,
  bannerTitle,
  bannerSubtitle,
  slug,
  seo,
  faq,
  contents,
  features,
  sections,
  selectedCategory,
  selectedBrand,
  requireCatalogFields = false,
}) => {
  const errors = {};

  if (!images?.banner?.file && !images?.banner?.preview) {
    errors.bannerImage = "Banner Image is required.";
  }
  if (!images?.section?.file && !images?.section?.preview) {
    errors.sectionImage = "Introduction Section Image is required.";
  }
  if (!text(bannerTitle)) errors.bannerTitle = "Name / Banner Title is required.";
  if (!text(bannerSubtitle)) {
    errors.bannerSubtitle = "Short Description / Banner Subtitle is required.";
  }
  if (!text(slug)) errors.slug = "Slug is required.";
  if (!text(seo?.title)) errors.seoTitle = "SEO Title is required.";
  if (!text(seo?.description)) {
    errors.seoDescription = "SEO Description is required.";
  }
  if (!(seo?.keywords || []).some((keyword) => text(keyword))) {
    errors.seoKeywords = "At least one SEO Keyword is required.";
  }
  if (requireCatalogFields && !selectedCategory) {
    errors.category = "Category is required.";
  }
  if (requireCatalogFields && !selectedBrand) {
    errors.brand = "Brand is required.";
  }

  (faq || []).forEach((item, index) => {
    if (!text(item?.ques) && !text(item?.ans)) return;
    if (!text(item.ques)) {
      errors[`faq.${index}.ques`] = `FAQ ${index + 1} Question is required.`;
    }
    if (!text(item.ans)) {
      errors[`faq.${index}.ans`] = `FAQ ${index + 1} Answer is required.`;
    }
  });
  const cleanedFaq = (faq || []).filter(
    (item) => text(item?.ques) || text(item?.ans),
  );

  return {
    errors,
    cleaned: {
      contents: cleanContents(contents),
      features: cleanFeatures(features),
      sections: cleanSections(sections),
      faq: cleanedFaq,
    },
  };
};

export const focusFirstInvalidField = () => {
  requestAnimationFrame(() => {
    const firstInvalid = document.querySelector("[data-error='true']");
    firstInvalid?.scrollIntoView({ behavior: "smooth", block: "center" });
    firstInvalid?.querySelector?.("input, textarea, select")?.focus();
  });
};

export const validationSummary = (errors) =>
  `Please complete the following required fields: ${Object.values(errors)
    .map((message) => message.replace(/\.$/, ""))
    .join(", ")}.`;

export const serializeSections = (sections) =>
  sections.map((section, index) => {
    const payload = { ...section, order: index };
    delete payload.imageFile;
    delete payload.videoFile;
    delete payload.imagePreview;
    delete payload.videoPreview;
    return payload;
  });